export const commercialQuestions = [
  {
    questionNumber: 1,
    choices: {
      A: "Mannequins are showcasing outfits.",
      B: "Shoppers are trying on clothes.",
      C: "Clothes are being placed on display racks.",
      D: "A large mirror is placed in front of the mannequins.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 마네킹이 옷을 입고 전시되어 있음\n" +
      "오답 설명: (B) 옷을 입어보는 손님이 보이지 않음, (C) 옷이 이미 진열되어 있음, (D) 거울이 보이지 않음",
  },
  {
    questionNumber: 2,
    choices: {
      A: "Shelves are being filled with products.",
      B: "Products are being labeled on the shelves.",
      C: "Shelves are stocked with various bottled beverages.",
      D: "The store aisle is being cleaned.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '선반에 다양한 음료가 진열되어 있다' → 선반에 여러 종류의 음료가 진열되어 있음\n\n오답 설명: (A) '선반이 상품으로 채워지는 중이다' → 이미 상품들이 선반에 채워져 있음,\n\n(B) '상품에 라벨링이 되어지는 중이다' → 라벨을 붙이는 사람이 보이지 않음, 이미 붙여져 있음,\n\n(D) '진열대 복도가 청소되어지는 중이다' → 청소하는 사람이 보이지 않음",
  },
  {
    questionNumber: 3,
    choices: {
      A: "Produce is being stacked on display.",
      B: "Produce is on display.",
      C: "Products are being moved to different sections.",
      D: "A shopping cart is near a refrigerated section.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 해설: (B) '농산물이 진열되어 있다' → 진열대에 농산물이 전시되어 있음\n\n오답 설명: (A) '농산품이 진열대에 채워지는 중이다' → 이미 농산품이 진열되어 있음, 채우는 사람이 없음,\n\n(C) '상품이 옮겨지는 중이다' → 옮기는 사람이 없음,\n\n(D) '냉장 코너 옆에 쇼핑카트가 있다' → 쇼핑카트가 보이지 않음",
  },
  {
    questionNumber: 4,
    choices: {
      A: "The dishes are being served.",
      B: "A menu is placed on each table.",
      C: "Tables have been set for dining.",
      D: "Napkins are being folded.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '테이블이 식사를 위해 세팅되어 있다' → 테이블이 식사 준비를 위해 정돈되어 있음\n\n오답 설명: (A) '음식이 서빙되고 있다' → 서빙하는 사람이 보이지 않음,\n\n(B) '각 테이블에 메뉴가 놓여있다' → 메뉴판이 보이지 않음,\n\n(D) '냅킨이 접혀지는 중이다' → 이미 접혀진 상태로 놓여있음",
  },
  {
    questionNumber: 5,
    choices: {
      A: "Some tables are set with plates and glasses.",
      B: "Dining furniture is being set up.",
      C: "Chairs are arranged around outdoor tables.",
      D: "A dining event is in progress.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '의자들이 야외 테이블 주변에 배치되어 있다' → 테이블 주변으로 의자가 놓여있음\n\n오답 설명: (A) '테이블 위에 접시와 유리잔이 놓여있다' → 접시와 유리잔이 보이지 않음,\n\n(B) '다이닝 퍼니처가 셋업되는 중이다' → 이미 셋업된 상태임,\n\n(D) '다이닝 이벤트가 진행중이다' → 다이닝 이벤트를 하는 사람들이 보이지 않음",
  },
  {
    questionNumber: 6,
    choices: {
      A: "An outdoor café has tables arranged along the sidewalk.",
      B: "Chairs have been stacked against the wall.",
      C: "A chalkboard sign is leaning against a chair.",
      D: "Potted plants are arranged on the ground.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 해설: (A) '야외 카페에 테이블이 보도를 따라 배치되어 있다' → 보도를 따라 테이블이 설치되어 있음\n\n오답 설명: (B) '의자가 벽에 기대어 쌓여있다' → 의자가 정상적으로 배치되어 있음,\n\n(C) '칠판 메뉴판이 의자에 기대어 있다' → 테이블 옆에 놓여 있음,\n\n(D) '화분이 바닥에 배치되어 있다' → 테이블 위에 놓여 있음",
  },
  {
    questionNumber: 7,
    choices: {
      A: "Awnings are being installed on the storefront.",
      B: "A seating area is set up outside a café.",
      C: "A street vendor is selling fresh produce.",
      D: "Pedestrians are walking past the store.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 해설: (B) '카페 외부에 좌석 공간이 설치되어 있다' → 카페 앞에 좌석이 마련되어 있음\n\n오답 설명: (A) '어닝이 설치되어지는 중이다' → 이미 설치되어 있음,\n\n(C) '노점상이 신선 식품을 판매하고 있다' → 노점상이 보이지 않음,\n\n(D) '보행자들이 가게 앞을 지나가고 있다' → 가게 앞을 지나가는 사람이 보이지 않음",
  },
  {
    questionNumber: 8,
    choices: {
      A: "The tables have been cleared of all utensils.",
      B: "Customers are dining at the tables.",
      C: "An outdoor dining area has been set up.",
      D: "The chairs have been stacked in a corner.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '야외 식사 공간이 설치되어 있다' → 야외에 식사 공간이 마련되어 있음\n\n오답 설명: (A) '테이블에서 모든 식기가 치워져 있다' → 테이블 위에 식기가 놓여 있음,\n\n(B) '손님들이 테이블에서 식사하고 있다' → 식사하는 사람이 보이지 않음,\n\n(D) '의자들이 구석에 쌓여있다' → 의자가 테이블 주변에 배치되어 있음",
  },
  {
    questionNumber: 9,
    choices: {
      A: "The awnings are fully rolled up.",
      B: "The chalkboard sign is placed on the ground near the entrance.",
      C: "The tables have been arranged indoors.",
      D: "A restaurant has outdoor seating along the sidewalk.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 해설: (D) '레스토랑에 보도를 따라 야외 좌석이 있다' → 보도를 따라 야외 테이블이 설치되어 있음\n\n오답 설명: (A) '차양이 완전히 말려올라가 있다' → 차양이 펼쳐져 있음,\n\n(B) '칠판 메뉴판이 입구 근처 바닥에 놓여있다' → 벽에 걸려 있음,\n\n(C) '테이블이 실내에 배치되어 있다' → 야외에 배치되어 있음",
  },
  {
    questionNumber: 10,
    choices: {
      A: "The chalkboard menus are being written.",
      B: "The outdoor seating area is covered with tablecloths.",
      C: "The outdoor furniture has been arranged.",
      D: "Lighting fixtures are being installed.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '야외 가구가 배치되어 있다' → 야외 테이블과 의자가 설치되어 있음\n\n오답 설명: (A) '칠판 메뉴판에 글씨가 쓰여지는 중이다' → 이미 쓰여진 상태임, 쓰는 사람이 보이지 않음,\n\n(B) '야외 좌석에 테이블보가 덮여있다' → 테이블보가 보이지 않음,\n\n(D) '라이팅 픽스쳐가 설치되어지는 중이다' → 설치하는 사람이 보이지 않음",
  },
  {
    questionNumber: 11,
    choices: {
      A: "The tables are positioned indoors near a window.",
      B: "A beachfront restaurant has outdoor seating on a wooden deck.",
      C: "The umbrellas are folded.",
      D: "A road runs alongside the seating area.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 해설: (B) '해변가 레스토랑에 나무 데크 위 야외 좌석이 있다' → 해변 앞 데크에 야외 좌석이 설치되어 있음\n\n오답 설명: (A) '테이블이 창가 실내에 위치해 있다' → 야외에 배치되어 있음,\n\n(C) '파라솔이 접혀있다' → 파라솔이 펼쳐져 있음,\n\n(D) '좌석 구역 옆으로 도로가 있다' → 도로가 아닌 해변이 있음",
  },
  {
    questionNumber: 12,
    choices: {
      A: "The windows have been left open.",
      B: "A narrow street is lined with outdoor dining tables.",
      C: "Hanging plants are being placed on the walls.",
      D: "Street lamps are mounted on the ground.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 해설: (B) '좁은 거리를 따라 야외 식사 테이블이 늘어서 있다' → 좁은 거리에 야외 테이블이 설치되어 있음\n\n오답 설명: (A) '창문이 열려있다' → 창문이 닫혀있음,\n\n(C) '행잉 플랜트가 벽에 놓여지는 중이다' → 놓는 사람이 보이지 않음, 이미 놓여져 있는 상태,\n\n(D) '스트릿램프가 바닥에 마운트되어 있다' → 조명이 보이나 바닥이 아닌 벽에 설치되어 있음",
  },
  {
    questionNumber: 13,
    choices: {
      A: "Chairs are neatly arranged around the tables.",
      B: "Some chairs are being moved.",
      C: "Chairs are placed upside down on the tables.",
      D: "Chairs have been stacked in the corner.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '의자들이 테이블 위에 거꾸로 놓여있다' → 테이블 위에 의자가 뒤집어져 있음\n\n오답 설명: (A) '의자들이 테이블 주변에 깔끔하게 배치되어 있다' → 의자들이 테이블 위에 뒤집혀 있음,\n\n(B) '의자들이 이동되어지는 중이다' → 이동하는 사람이 보이지 않음,\n\n(D) '의자들이 구석에 쌓여있다' → 의자가 테이블 위에 배치되어 있음",
  },
  {
    questionNumber: 14,
    choices: {
      A: "A large umbrella is shading an outdoor dining area.",
      B: "An outdoor dining area is being set up.",
      C: "The chairs are neatly stacked in a corner.",
      D: "The potted plants are placed on the tables.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 해설: (A) '큰 파라솔이 야외 식사 공간을 그늘지게 하고 있다' → 파라솔이 야외 테이블 위에 설치되어 있음\n\n오답 설명: (B) '야외 식사 공간이 셋업되어지는 중이다' → 셋업하는 사람이 보이지 않음,\n\n(C) '의자들이 구석에 깔끔하게 쌓여있다' → 의자가 테이블 주변에 배치되어 있음,\n\n(D) '화분이 테이블 위에 놓여있다' → 화분이 벽에 걸려있음",
  },

  {
    questionNumber: 15,
    choices: {
      A: "The chairs are facing each other.",
      B: "The ceiling is being decorated with hanging lights.",
      C: "The tables are occupied.",
      D: "The floor is being mopped.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 해설: (A) '의자들이 서로 마주보고 있다' → 의자들이 테이블을 중심으로 마주보도록 배치되어 있음\n\n오답 설명: (B) '천장이 행잉 라이트로 데코레이션되는 중이다' → 이미 설치된 상태, 데코레이션하는 사람 없음,\n\n(C) '테이블들이 사용중이다' → 테이블에 앉아있는 사람이 없음,\n\n(D) '바닥이 닦여지는 중이다' → 바닥 닦는 사람이 없음",
  },
  {
    questionNumber: 16,
    choices: {
      A: "The chairs have padded seats.",
      B: "The tables are set with plates and cutlery.",
      C: "A stack of stools is placed in the corner.",
      D: "Stools are placed along the counter.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 해설: (D) '스툴이 카운터를 따라 놓여있다' → 카페나 바에서 창가에 있는 높은 테이블을 카운터 라고도 합니다. \n\n오답 설명: (A) '의자에 패딩 시트가 있다' → 의자에 패딩이 없음,\n\n(B) '테이블에 접시와 식기가 놓여있다' → 테이블 위에 식기가 보이지 않음,\n\n(C) '스툴이 구석에 쌓여있다' → 스툴이 구석에 있긴 하나 쌓여있지 않음.",
  },
  {
    questionNumber: 17,
    choices: {
      A: "The products are being wrapped.",
      B: "A shelf is stocked with folded garments.",
      C: "Outerwear is displayed on a rack.",
      D: "The clothes are being hung on hangers.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '아우터웨어가 행거에 전시되어 있다' → 외투류가 옷걸이에 걸려 진열되어 있음\n\n오답 설명: (A) '상품들이 포장되어지는 중이다' → 포장하는 사람이 보이지 않음,\n\n(B) '선반에 접힌 옷들이 진열되어 있다' → 옷이 선반이 아닌 행거에 걸려있음,\n\n(D) '옷들이 옷걸이에 걸려지는 중이다' → 이미 걸려있는 상태임",
  },
  {
    questionNumber: 18,
    choices: {
      A: "Mannequins are dressed in casual apparel.",
      B: "The clothes are being tailored.",
      C: "Jackets are displayed on a shelf.",
      D: "The garments are being folded.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 해설: (A) '마네킹이 캐주얼한 의류를 입고 있다' → 마네킹에 캐주얼 의류가 전시되어 있음\n\n오답 설명: (B) '옷들이 테일러링되는 중이다' → 수선하는 사람이 보이지 않음,\n\n(C) '자켓이 선반에 진열되어 있다' → 자켓이 선반이 아닌 다른 곳에 있음,\n\n(D) '의류들이 접혀지는 중이다' → 접는 사람이 없음, 이미 접혀져 있음",
  },
  {
    questionNumber: 19,
    choices: {
      A: "The shoes are being tried on.",
      B: "The shoes have been arranged in boxes.",
      C: "The products are being restocked.",
      D: "Footwear is displayed on multiple shelves.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 해설: (D) '신발이 여러 선반에 진열되어 있다' → 다수의 신발이 여러 층의 선반에 전시되어 있음\n\n오답 설명: (A) '신발이 신겨지는 중이다' → 신발 신어보는 사람이 보이지 않음,\n\n(B) '신발이 박스에 정리되어 있다' → 신발이 박스가 아닌 선반에 있음,\n\n(C) '상품이 채워지는 중이다' → 채우는 사람이 보이지 않음",
  },

  {
    questionNumber: 20,
    choices: {
      A: "A bakery display is filled with pastries.",
      B: "A street vendor is selling fresh vegetables.",
      C: "Potted plants and flowers are arranged outside a shop.",
      D: "A bouquet is being wrapped at the counter.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '화분에 심은 식물과 꽃이 상점 밖에 진열되어 있다' → 가게 앞에 화분과 꽃이 전시되어 있음\n\n오답 설명: (A) '베이커리 진열대에 페이스트리가 가득하다' → 빵이 아닌 꽃이 진열되어 있음,\n\n(B) '노점상이 신선한 채소를 판매하고 있다' → 채소가 아닌 꽃이 진열되어 있음,\n\n(D) '부케가 카운터에서 포장되고 있다' → 포장하는 사람이 보이지 않음",
  },
  {
    questionNumber: 21,
    choices: {
      A: "A display case is filled with assorted pastries.",
      B: "A tray of desserts is being placed in the oven.",
      C: "Customers are selecting items from the counter.",
      D: "Baked goods are being packaged for sale.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 해설: (A) '진열장에 다양한 페이스트리가 가득하다' → 진열장에 여러 종류의 빵과 디저트가 전시되어 있음\n\n오답 설명: (B) '디저트 트레이가 오븐에 들어가는 중이다' → 오븐에 넣는 사람이 보이지 않음,\n\n(C) '손님들이 카운터에서 상품을 고르고 있다' → 상품을 고르는 사람이 보이지 않음,\n\n(D) '베이커리 상품이 판매를 위해 포장되는 중이다' → 포장하는 사람이 보이지 않음",
  },

  {
    questionNumber: 22,
    choices: {
      A: "A store employee is assisting a customer at the checkout.",
      B: "A dining table is set with plates and cutlery.",
      C: "Various kitchenware items are displayed on shelves.",
      D: "Some dishes are being arranged on the shelves.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '다양한 주방용품이 선반에 진열되어 있다' → 여러 종류의 주방용품이 선반에 전시되어 있음\n\n오답 설명: (A) '직원이 계산대에서 손님을 돕고 있다' → 직원과 손님이 보이지 않음,\n\n(B) '식탁에 접시와 식기가 세팅되어 있다' → 접시와 식기가 테이블이 아닌 선반에 있음,\n\n(D) '접시들이 선반에 정리되는 중이다' → 정리하는 사람이 보이지 않음",
  },
  {
    questionNumber: 23,
    choices: {
      A: "The furniture is being assembled.",
      B: "Shelves are stocked with storage units.",
      C: "The furniture is being lifted.",
      D: "A row of sofas is displayed near the entrance.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 해설: (B) '선반에 수납장이 진열되어 있다' → 선반에 수납용 가구가 전시되어 있음\n\n오답 설명: (A) '가구들이 조립되어지는 중이다' → 조립하는 사람이 없음, 이미 조립되어 있는 상태임,\n\n(C) '가구가 들려지는 중이다' → 가구를 드는 사람이 보이지 않음,\n\n(D) '소파가 입구 근처에 진열되어 있다' → 소파가 보이지 않음",
  },
  {
    questionNumber: 24,
    choices: {
      A: "A vendor is arranging vegetables on the shelves.",
      B: "Customers are selecting produce at an indoor grocery store.",
      C: "A weighing scale is placed on the counter.",
      D: "Fresh produce is displayed in wooden crates.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 해설: (D) '신선한 농산물이 나무 상자에 진열되어 있다' → 사진 속 신선한 농산물이 나무 상자에 진열되어 있으므로 유일한 정답\n\n오답 설명:\n\n(A) '판매자가 선반에 채소를 정리하고 있다' → 채소가 진열되어 있지만 실제로 정리하는 사람이 보이지 않음,\n\n(B) '고객들이 실내 식료품점에서 농산물을 고르고 있다' → 야외 시장이므로 실내 식료품점이 아님,\n\n(C) '저울이 카운터에 놓여있다' → 시장 풍경이지만 저울은 보이지 않음",
  },
  {
    questionNumber: 25,
    choices: {
      A: "A cashier is scanning a bag of groceries.",
      B: "The digital scale is turned off.",
      C: "A plastic bag is filled with apples.",
      D: "A receipt is being printed from the machine.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '비닐봉지에 사과가 가득 차 있다' → 사진 속 비닐봉지 안에 사과가 가득 차 있으므로 유일한 정답\n\n오답 설명:\n\n(A) '계산원이 식료품 봉지를 스캔하고 있다' → 무게를 재는 장면이지만 계산대에서 바코드를 스캔하는 장면이 아님,\n\n(B) '전자 저울이 꺼져있다' → 전자 저울이 켜져 있고 무게가 표시되고 있음,\n\n(D) '기계에서 영수증이 출력되고 있다' → 전자 저울은 있지만 영수증이 출력되는 모습은 보이지 않음",
  },
  {
    questionNumber: 26,
    choices: {
      A: "A display case is filled with assorted pastries.",
      B: "A tray of desserts is being placed in the oven.",
      C: "Customers are selecting items from the counter.",
      D: "Baked goods are being packaged for sale.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 해설: (A) '진열장에 다양한 종류의 페이스트리가 가득 차 있다' → 유리 진열장에 여러 종류의 빵과 구운 제품들이 진열되어 있음\n\n오답 설명:\n\n(B) '디저트 트레이가 오븐에 들어가고 있다' → 구운 제품은 있지만 오븐에 트레이를 넣는 장면은 없음,\n\n(C) '고객들이 카운터에서 제품을 고르고 있다' → 사진에서 고객이 보이지 않음,\n\n(D) '구운 제품들이 판매를 위해 포장되고 있다' → 포장된 빵은 보이지만 실제로 포장하는 모습은 없음",
  },
  {
    questionNumber: 27,
    choices: {
      A: "A diary is open on the counter.",
      B: "Several yogurt containers are displayed in the store.",
      C: "Different types of dairy products are arranged for sale.",
      D: "A customer is tasting a cheese sample.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '다양한 유제품이 판매를 위해 진열되어 있다' → 여러 종류의 치즈와 유제품이 판매를 위해 정리되어 있음\n\n오답 설명:\n\n(A) '다이어리가 카운터에 펼쳐져 있다' → 치즈가 진열되어 있지만 다이어리는 보이지 않음,\n\n(B) '여러 개의 요구르트 용기가 가게에 진열되어 있다' → 유제품 가게이지만 요구르트는 보이지 않음,\n\n(D) '고객이 치즈 샘플을 시식하고 있다' → 치즈는 있지만 시식하는 고객은 보이지 않음",
  },
  {
    questionNumber: 28,
    choices: {
      A: "Some people are sitting under the umbrellas.",
      B: "A waiter is serving drinks at an outdoor café.",
      C: "Umbrellas are shading the tables.",
      D: "The benches have been stacked in a corner.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '파라솔이 테이블에 그늘을 만들어주고 있다' → 사진 속 파라솔이 테이블에 그늘을 만들어주고 있으므로 유일한 정답\n\n오답 설명:\n\n(A) '몇 명의 사람들이 파라솔 아래에 앉아있다' → 테이블과 파라솔은 있지만 사람이 없음,\n\n(B) '웨이터가 야외 카페에서 음료를 서빙하고 있다' → 야외 테이블은 있지만 웨이터가 서빙하는 모습은 보이지 않음,\n\n(D) '벤치가 구석에 쌓여있다' → 벤치가 있지만 구석에 쌓여있지 않고 배치되어 있음",
  },
  {
    questionNumber: 29,
    choices: {
      A: "A cashier is helping a customer at the checkout counter.",
      B: "Some clothes are folded neatly on a display table.",
      C: "Clothes are hanging on racks in a clothing store.",
      D: "A sales associate is arranging garments on a rack.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '옷들이 의류 매장의 옷걸이에 걸려있다' → 사진 속 다양한 옷이 매장의 옷걸이에 걸려있으므로 유일한 정답\n\n오답 설명:\n\n(A) '계산원이 계산대에서 고객을 돕고 있다' → 매장 안의 옷들은 보이지만 계산대나 고객이 보이지 않음,\n\n(B) '일부 옷들이 진열대 위에 깔끔하게 접혀있다' → 옷들이 걸려있지만 진열대 위에 접힌 옷은 보이지 않음,\n\n(D) '판매 직원이 옷걸이에 의류를 정리하고 있다' → 옷들이 정리되어 있지만 판매 직원이 정리하는 모습은 보이지 않음",
  },
  {
    questionNumber: 30,
    choices: {
      A: "Some mannequins are displaying outfits near the entrance.",
      B: "A salesperson is assisting a customer.",
      C: "Shirts are neatly folded on display tables.",
      D: "A pile of clothing is scattered across the floor.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 해설: (C) '셔츠가 진열대에 깔끔하게 접혀 있다' → 사진 속 셔츠가 진열대에 깔끔하게 접혀 있으므로 유일한 정답\n\n오답 설명:\n\n(A) '마네킹이 입구 근처에서 의상을 전시하고 있다' → 의류 매장이지만 마네킹이 보이지 않음,\n\n(B) '판매원이 고객을 돕고 있다' → 매장에 옷은 많지만 점원과 고객이 보이지 않음,\n\n(D) '옷 더미가 바닥에 흩어져 있다' → 옷들이 깔끔하게 정리되어 있으며, 바닥에 흩어져 있지 않음",
  },
];
